import { Col, Stack, Container } from "react-bootstrap";
import { getScoreTrendLabel } from "../HelperFunctions";
import { useMemo, useState } from "react";
import moment from "moment/min/moment-with-locales";
import LoadingIndicator from "../LoadingIndicator";
import ErrorResponse from "../ErrorResponse";
import ExportData from "../../components/ExportData";
import useSortableData from "../../components/useSortableData";
import SongSearchInput from "../SearchInput";
import EmptyRow from "../EmptyRow";
import SongScoresHeader from "./SongScoresHeader";
import SongScoreRow from "./SongScoreRow";
import SongCatalogueModal from "../songCatalogue/SongCatalogueModal";

export default function TopFlopSongsTable({ data, loading, error, type }) {
    const [catalogueSong, setCatalogueSong] = useState(null);
    const [filterData, setFilterData] = useState({ searchString: "" });

    const songsDataMemo = useMemo(() => {
        if (data) {
            let filteredData = data;
            if (filterData.searchString) {
                filteredData = filteredData.filter(
                    x =>
                        x.song.artist.toLowerCase().includes(filterData.searchString.toLowerCase().trim()) ||
                        x.song.title.toLowerCase().includes(filterData.searchString.toLowerCase().trim()) ||
                        x.song.release_year?.toString().includes(filterData.searchString.trim()) ||
                        moment(x.music_test_data.first_play).format("L")?.toString().toLowerCase().includes(filterData.searchString.trim())
                );
            }
            return filteredData;
        }
    }, [data, filterData.searchString]);

    const { sortedItems, requestSort, sortConfig } = useSortableData(songsDataMemo);

    const csvHeaders = ["Artist", "Title", "Release Year", "Score", "Trend", "First Play"];
    const csvData = useMemo(() => {
        if (!sortedItems) return [];
        return sortedItems.map(x => [
            x.song.artist,
            x.song.title,
            x.song.release_year,
            x.music_test_data.song_score,
            getScoreTrendLabel(x.music_test_data.song_score_trend),
            moment(x.music_test_data.first_play).format("L HH:mm"),
        ]);
    }, [sortedItems]);

    return (
        <>
            {loading ? (
                <LoadingIndicator width={75} />
            ) : error ? (
                <ErrorResponse errorCode={error} />
            ) : (
                data && (
                    <>
                        <Stack direction="horizontal" gap={2} className=" mb-2 flex-wrap-reverse">
                            <Col xs xl={5}>
                                <SongSearchInput filterData={filterData} setFilterData={setFilterData} />
                            </Col>
                            <Col xs={"auto"} className="ms-auto">
                                <Stack direction="horizontal" gap={1} className="ms-xl-auto w-100 w-xl-auto order-first order-xl-last">
                                    <span className="me-1 d-none d-md-inline-block">Download:</span>
                                    <ExportData data={csvData} headers={csvHeaders} filename={`${type} 10 Songs`} />
                                </Stack>
                            </Col>
                        </Stack>
                        <SongScoresHeader sortConfig={sortConfig} requestSort={requestSort} />
                        <Container fluid>
                            {sortedItems?.length ? (
                                sortedItems.map(x => <SongScoreRow key={x.song.item_id} item={x} setCatalogueSong={setCatalogueSong} />)
                            ) : (
                                <EmptyRow text="No Songs" />
                            )}
                        </Container>
                    </>
                )
            )}
            <SongCatalogueModal show={!!catalogueSong} onHide={() => setCatalogueSong(null)} song={catalogueSong} />
        </>
    );
}
